import React, { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import RouteLoader from "./component/shared/RouteLoader";
import AppRoutes from './app-routes'
import AuthRoutes from './auth-routes'

const App = (props) => {
  const navigate = useNavigate();
  const { user, tokenDetails } = useAuth();
  const [canLoadApp, setCanLoadApp] = useState(false);

  useEffect(() => {
    if (user && tokenDetails) {
      setCanLoadApp(true);
    } else {
      setCanLoadApp(false);
      navigate("/login");
    }
  }, [user, tokenDetails]);

  return (
    <Suspense fallback={<RouteLoader />}>
      {canLoadApp ? <AppRoutes {...props} /> : <AuthRoutes {...props} />}
    </Suspense>
  )
};

export default App;